import React, { useEffect, useState } from "react";
import { FileText, ZoomIn } from "lucide-react";
import { apiClient } from "@/lib/apiClient";

/** Vorschaubild (PDF: erste Seite) mit Lupe – Klick öffnet die grosse Ansicht. */
export const DocThumb = ({ url, title, onOpen, className = "", testid = "doc-thumb" }) => {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!url) return undefined;
    let obj = null;
    let cancelled = false;
    apiClient.get(`${url}${url.includes("?") ? "&" : "?"}thumb=1`, { responseType: "blob" })
      .then((r) => { if (!cancelled) { obj = URL.createObjectURL(r.data); setSrc(obj); } })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; if (obj) URL.revokeObjectURL(obj); };
  }, [url]);

  return (
    <button
      type="button"
      onClick={onOpen}
      title={`${title || "Dokument"} – gross ansehen`}
      className={`group relative overflow-hidden rounded-md border border-slate-200 bg-slate-50 shrink-0 ${className}`}
      data-testid={testid}
    >
      {src && !failed ? (
        <img src={src} alt={title || "Vorschau"} className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-105" />
      ) : (
        <div className="h-full w-full flex items-center justify-center text-slate-400"><FileText className="h-6 w-6" /></div>
      )}
      <span className="absolute inset-0 flex items-center justify-center bg-slate-900/0 transition-colors group-hover:bg-slate-900/35">
        <ZoomIn className="h-5 w-5 text-white opacity-80 drop-shadow transition-opacity group-hover:opacity-100" />
      </span>
    </button>
  );
};
